import {createAsyncThunk} from '@reduxjs/toolkit';
import {getEnv} from '../../../../../../common/env/env';
import {fetchStrictly} from '../../../../../../common/shared/api/fetchStrictly';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {TalkViewerErrorType} from '../../../../../../errors/TalkViewerErrorType.enum';
import {thunkSerializeError} from '../../../../../../errors/thunkSerializeError.function';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {AppState} from '../../../../../../state/store';
import {TALK_VIEWER_STATE_NAME} from '../constant/talkViewerConstant';
import {TalkViewerResponseVo} from '../type/TalkViewerResponse.interface';

export const fetchTalkViewerContentFromAdminSite = createAsyncThunk<
  {
    preview: TalkViewerResponseVo;
    episodeTitle: string;
    title: string;
    viewerInfoData: ViewerInfo;
  },
  {serviceEpisodeUid: number},
  {state: AppState; serializedErrorType: SerializedPagewebError}
>(
  `${TALK_VIEWER_STATE_NAME}/fetchTalkViewerContentFromAdminSite`,
  async ({serviceEpisodeUid}, {rejectWithValue}) => {
    try {
      const contentUrl = `${
        getEnv().adminSiteHost
      }/exid/internal-api/katalk_preview_data?uid=${serviceEpisodeUid}`;
      const previewTalkDataResponse = await (
        await fetchStrictly(contentUrl)
      ).json();
      return {
        preview: JSON.parse(previewTalkDataResponse.preview),
        episodeTitle: previewTalkDataResponse.episodeTitle,
        title: previewTalkDataResponse.title,
        viewerInfoData: previewTalkDataResponse.viewerInfo,
      };
    } catch {
      return rejectWithValue(TalkViewerErrorType.UnknownError);
    }
  },
  {
    serializeError: thunkSerializeError,
  }
);
